// Scheme Report — scheme usage on Secondary (retailer) orders only.
// Bifurcated from Primary Scheme Report so the two channels don't mix in
// one report (matches the existing Order Report vs Primary Order Report split).
import TransactionReportPage from "./TransactionReportPage";

export default function SchemeReport() {
  return (
    <TransactionReportPage
      slug="scheme"
      testidPrefix="scheme-report"
      title="Scheme Report"
      subtitle="Every Secondary order line a scheme fired on — reward given, discount, free qty."
      initialDaysBack={30}
      filterConfig={{ showUser: true, showDistributor: true }}
    />
  );
}
